import React from 'react';
import styled from '@emotion/styled';
import { ProductListItem } from '../../types/types';
import { StyleLibrary } from '@vm/omega-shared-component-webapp';
import { RadioInputWithLabel } from '../shared/Form/RadioInputWithLabel';

const { mqBreakpoints, pxToRem } = StyleLibrary;

const Li = styled.li<{ isSelected: boolean }>(props => ({
  background: props.isSelected ? 'var(--color-lime)' : 'var(--color-white)',
  listStyleType: 'none',
  width: '100%',
  cursor: 'pointer',
}));

const ItemContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  width: 'inherit',
  padding: `${pxToRem(16)} ${pxToRem(24)}`,

  label: {
    marginBottom: 0,
  },
  [mqBreakpoints.tablet]: {
    paddingBottom: `${pxToRem(24)}`,
  },
});

type Props = {
  tile: ProductListItem;
  index: number;
  isSelected: boolean;
  onClick: (i: number) => void;
};

export const Tile: React.FC<Props> = ({ tile, index, isSelected, onClick }) => {
  const metadata = tile?.product?.metadata;
  const productId = tile?.product?.productId;
  const name = metadata?.title; // these are swapped around in Java: title <-> name

  const id = `product-${index}`;
  const formattedName = name ? name.replace(/\s/g, '-').toLowerCase() : '';

  return (
    <Li isSelected={isSelected} onClick={() => onClick(index)} data-testid={`mp-tile-${productId}`}>
      <ItemContainer>
        <RadioInputWithLabel id={`radio-${id}-${index}-${formattedName}`} data-testid={`radio-${id}-${formattedName}`} checked={isSelected} value={formattedName} label={name} onChange={() => onClick(index)} />
      </ItemContainer>
    </Li>
  );
};
